import React from 'react';
import { translate } from 'jitsi/base/i18n/functions';
import { Audio } from 'jitsi/base/media/components/index.web';
import Button from 'jitsi/base/ui/components/web/Button';
import { BUTTON_TYPES } from 'jitsi/base/ui/constants.any';
import { AudioOutputPreview, TEST_SOUND_PATH, } from 'jitsi/device-selection/components/AudioOutputPreview.web';
class IISightAudioOutputPreview extends AudioOutputPreview {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { accessibilityLabel: this.props.t('deviceSelection.testAudio'), className: this.props.className, labelKey: 'deviceSelection.testAudio', onClick: this._onClick, onKeyPress: this._onKeyPress, type: BUTTON_TYPES.PRIMARY }),
            React.createElement(Audio, { setRef: this._audioElementReady, src: TEST_SOUND_PATH })));
    }
}
export default translate(IISightAudioOutputPreview);
